import { render } from "./Creterias.vue?vue&type=template&id=6773a476&scoped=true"
import script from "./Creterias.vue?vue&type=script&lang=js"
export * from "./Creterias.vue?vue&type=script&lang=js"

import "./Creterias.vue?vue&type=style&index=0&id=6773a476&scoped=true&lang=css"

import exportComponent from "/Users/user/Desktop/Проекты/territory_transport/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6773a476"]])

export default __exports__